import { getGlobals } from '@/lib/globals';
import { logger } from '@/lib/logger';

//APP DOWNLOAD BANNER
export const HTML_TAG_REG_EXP = /^<[a-z]+ nonce=".*">(.+)<\/[a-z]+>$/;
export const APP_DOWNLOAD_CONTAINER_ID = 'app-download-banner';

/**
 * exporting only for testing purpose
 */
export const createAppDownloadBannerElement = (
  str: string,
  tagName: string,
): HTMLElement => {
  const el = document.createElement(tagName);

  // `commonutils-client` returns the script and styles as a string. We need
  // to strip the tags from the string so we are only inserting the code.
  el.textContent = str.replace(HTML_TAG_REG_EXP, '$1');
  el.nonce = getGlobals().nonce;

  return el;
};

export const setDownloadAppBanner = ({
  receiptPageTestId,
  css,
  html,
  js,
}: {
  receiptPageTestId: string;
  css: string;
  html: string;
  js: string;
}): void => {
  if (!css || !html || !js) {
    logger.info('app_download_banner_scripts_not_available');
    return;
  }

  const receiptPageWPS = document.querySelector(
    `[data-testid=${receiptPageTestId}]`,
  );

  if (!receiptPageWPS) {
    logger.info('app_download_banner_insert_failed_interstitial_missing');
    return;
  }

  const fragment = document.createDocumentFragment();
  const markupContainer = document.createElement('div');
  markupContainer.innerHTML = html;

  const { nonce } = getGlobals();
  const bannerEl = markupContainer.firstElementChild;

  if (!bannerEl) {
    logger.info('app_download_banner_invalid_html');
    return;
  }

  bannerEl.setAttribute('data-testid', APP_DOWNLOAD_CONTAINER_ID);

  const styleEl = createAppDownloadBannerElement(css, 'style');
  const scriptEl = createAppDownloadBannerElement(js, 'script');

  styleEl.setAttribute('nonce', nonce);
  scriptEl.setAttribute('nonce', nonce);
  fragment.appendChild(bannerEl);
  fragment.appendChild(styleEl);
  fragment.appendChild(scriptEl);

  const interstitialOverlay = receiptPageWPS.firstChild;
  // @ts-expect-error
  interstitialOverlay?.prepend(fragment);

  logger.info('app_download_banner_inserted_into_dom');
};
